angular.module('tgaAdmin')
  .service('xapiService', ['$http', 'domainService',
    function ($http, domainService) {
      let token = null;

      function getToken(endpoint, auth) {
        return $http({
          method: 'POST',
          url: `${endpoint}lrs`,
          headers: {
            'Content-Type': 'application/json',
            Authorization: auth,
          },
          data: {
            name: 'TGA',
            fingerPrint: `organization:tta-${domainService.domain}`,
          },
        }).then(
          (response) => {
            token = response.data.data?.token;
            return response.data;
          },
          (error) => {
            throw error.data;
          },
        );
      }

      function getStatements(endpoint, auth, params) {
        return $http({
          method: 'GET',
          url: `${endpoint}statements`,
          headers: {
            Authorization: auth,
            'X-Experience-API-Version': '1.0.3',
          },
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCourses(endpoint, params) {
        return $http({
          method: 'GET',
          url: `${endpoint}dashboard/courses`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCourse(endpoint, courseId, params) {
        return $http({
          method: 'GET',
          url: `${endpoint}dashboard/courses/${courseId}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getStatements,
        getToken,
        getCourses,
        getCourse,
      });
    }]);
